import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { ViewType } from '../../assets/constants'
import { selectPrimarySecurity } from '../../selectors/home'
import { getPathForSecurity, isFnOSecurity } from '../../util/security'
import commonActions from '../../actions/common.actions'
import store from '../../store'

/** Sync navigation URL when primary security identity changes — not on snapshot ticks. */
export function useHomeLayoutNavigation(view: ViewType) {
    const dispatch = useDispatch()
    const prevNavKeyRef = useRef('')

    useEffect(() => {
        const sync = () => {
            const { expressionMode, primary, underlying } = selectPrimarySecurity(store.getState())
            const selectedSecurity = expressionMode ? null : (primary && isFnOSecurity(primary) ? underlying : primary)
            if (!selectedSecurity) return

            const navKey = `${view}:${selectedSecurity.exchange}:${selectedSecurity.code}`
            if (navKey === prevNavKeyRef.current) return
            prevNavKeyRef.current = navKey

            commonActions.setNavigationUrl(dispatch, {
                viewType: view,
                url: getPathForSecurity(view, selectedSecurity)
            })
        }
        sync()
        return store.subscribe(sync)
    }, [dispatch, view])
}
